<template>
  <div class="krs027">
    <div class="tb-list_ty2">
      <div class="tb-header">
        <div class="top clear">
          <div class="tb_num fl">
            <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: folderListFilter.length})">
              <!-- 총 <b>{{ folderListFilter.length }}</b>건 -->
            </div>
            <!-- 검색 조회시 노출 S -->
            <div class="check_result" v-if="isSearchDataExists == true">
              <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchValue, cnt: folderListFilter.length})">
                <!-- “{{ rtnSearchValue }}” 검색 결과 총<b>{{ folderListFilter.length }}</b>건 -->
              </div>
              <button type="button" @click="clearSearchFolder">초기화</button>
            </div>
            <!-- //검색 조회시 노출 E -->
          </div>
        </div>
        <div class="btm clear">
          <div class="fl">
            <!-- <dl class="dl_layer select_ty1"> -->
            <span>{{$i18nUtil.trans("message.ProjectFolderManage.001","선택 과정")}} </span>
            <button
              type="button"
              class="btn-primary-small"
              @click="deleteFolder"
            >{{ $i18nUtil.trans("button.delete","삭제") }}</button>
            <!-- </dl> -->
          </div>

          <div class="tb_sort fr">
            <!-- <dl class="dl_layer select_ty3 right">
              <dt id="dtSearchType">
                <button
                  type="button"
                  @click="
                    $event.target.parentElement.classList.toggle('active')
                  "
                >
                  {{
                    selectedSearchType == "CATEGORY_NAME" ? "명" : "생성자"
                  }}
                </button>
              </dt>
              <dd style="width: 86px">
                <ul>
                  <li @click="filterSearchType($event, 'CATEGORY_NAME')">
                    <button type="button">명</button>
                  </li>
                  <li @click="filterSearchType($event, 'REG_USER_NAME')">
                    <button type="button">생성자</button>
                  </li>
                </ul>
              </dd>
            </dl> -->

            <div class="dropdown ty2 relative">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">{{
                    selectedSearchType == "CATEGORY_NAME" ? $i18nUtil.trans("entity.category.depth2.name","과정명") : $i18nUtil.trans("message.ProjectFolderManage.002","생성자")
                  }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div
                    class="dropdown-list-item"
                    @click="filterSearchType('CATEGORY_NAME')"
                  >
                    <div class="tit">
                      <button
                        type="button"
                        :class="
                          selectedSearchType == 'CATEGORY_NAME' ? 'active' : ''
                        "
                      >
                        {{$i18nUtil.trans("entity.category.depth2.name","과정명")}}
                      </button>
                    </div>
                  </div>
                  <div
                    class="dropdown-list-item"
                    @click="filterSearchType('REG_USER_NAME')"
                  >
                    <div class="tit">
                      <button
                        type="button"
                        :class="
                          selectedSearchType == 'REG_USER_NAME' ? 'active' : ''
                        "
                      >
                        {{ $i18nUtil.trans($i18nUtil.trans("message.ProjectFolderManage.002","생성자")) }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>

            <form action="" @submit.prevent="false == false">
              <div class="search_ty1">
                <input
                  type="text"
                  @focus="$event.target.placeholder = ''"
                  @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  :placeholder="$i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  :class="searchValue == '' ? 'ico_search' : ''"
                  @keyup.enter="getProjectFolderManageList(true)"
                  v-model="searchValue"
                  maxlength="21"
                />
                <button
                  type="reset"
                  class="input-txt-del"
                  @click="searchValue = ''"
                  v-if="searchValue != ''"
                >
                  입력 삭제
                </button>
                <button
                  type="reset"
                  class="btn_search"
                  @click="getProjectFolderManageList(true)"
                >
                  검색
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- //tb-header -->

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="folderListFilter"
        :single-select="singleSelect"
        show-select
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :sort-by="['regDate']"
        :sort-desc="[true]"
        item-key="categoryMid"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents"
      >
        <template v-slot:item.categoryName="{ item }">
          <div class="txt" v-if="item.txt == 'txt' && item.edit != 'edit'">
            {{ item.categoryName }}
            <button
              type="button"
              class="btn_edit"
              @click="folderEdit($event, item)"
            >
              수정
            </button>
          </div>
          <div class="eidt-box" v-if="item.edit == 'edit'">
            <form action="">
              <div class="input-box">
                <input
                  type="text"
                  required
                  :placeholder='$i18nUtil.trans("UB006.003")'
                  v-model="item.newCategoryName"
                  :id="`inputFolder_` + item.categoryMid"
                  @input="displayBytes(maxBytes, item, $event)"
                  @keyup.enter="applyCategoryName(item)"
                />
                <button
                  type="reset"
                  class="input-txt-del"
                  @click="(item.newCategoryName = ''), (item.error = true)"
                >
                  입력 삭제
                </button>
                <!-- <div class="error" v-if="item.editError == 'ERROR'">
                    입력 가능한 글자수를 초과하였습니다. [입력가능 [{{item.checkBytes == null ? getByteLength(item.categoryName) : item.checkBytes}}/25]byte정보 노출]
                </div> -->
                <div class="error" v-if="item.editError == 'ERROR'">
                  {{
                    $i18nUtil.trans("UB008", {
                      textLength:
                        item.newCategoryName == null
                          ? 0
                          : item.newCategoryName.length,
                      byteLength: item.checkBytes,
                      maxByteLength: maxBytes,
                    })
                  }}
                </div>
                <div
                  class="error"
                  v-if="item.error != null && item.error == true"
                >
                  {{ $i18nUtil.trans("UB006") }}
                </div>
                <!-- <div
                  class="error"
                  v-if="
                    item.duplicateError != null && item.duplicateError == true
                  "
                >
                  {{ $i18nUtil.trans("UB024") }}
                </div> -->
              </div>
            </form>
            <div class="btn-box">
              <button
                type="button"
                class="btn-txt-primary"
                @click="
                  (item.newCategoryName = item.categoryName), (item.edit = '')
                "
              >
                {{ $i18nUtil.trans("button.cancel","취소") }}
              </button>
              <button
                type="button"
                class="btn-txt-primary black"
                @click="applyCategoryName(item)"
              >
                {{ $i18nUtil.trans("button.save","저장") }}
              </button>
            </div>
          </div>
        </template>
        <template v-slot:item.regDate="{ item }">
          <div>
            {{ convertDateDotYMD(item.regDate) }}
          </div>
        </template>
        <template v-slot:item.regUserName="{ item }">
          <div>
            {{ item.regUserName }}
          </div>
        </template>
        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="isSearchDataExists">{{$i18nUtil.trans("search.007","조회된 결과가 없습니다.")}}</v-alert>
            <v-alert :value="!isSearchDataExists">{{$i18nUtil.trans("search.014","등록된 과정이 없습니다.")}}</v-alert>
          </div>
        </template>
      </v-data-table>

      <div class="pagination">
        <v-pagination
          v-model="page"
          circle
          :length="pageCount"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <!-- //tb-list_ty1 -->

    <!-- <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="changedInfoSave">변경사항 저장</button>
        </footer> -->
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    info: Object,
  },
  data() {
    return {
      projectId: null,
      groupId: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      singleSelect: false,
      selected: [],
      isSearchDataExists: false,
      changedFolderList: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.category.depth2.name","과정명"), value: "categoryName", sortable: false },
        {
          text: this.$i18nUtil.trans("entity.category.filter.paperCount","생성보드 수"),
          align: "center",
          value: "paperCount",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.category.filter.regDate","생성일"), align: "center", value: "regDate", sortable: false },
        {
          text: this.$i18nUtil.trans("entity.category.filter.regUser","생성자"),
          align: "center",
          value: "regUserName",
          sortable: false,
        },
        // { text: '대시보드 속성', align: 'center',value: 'sectionName', sortable: false },
        // { text: '평가정보', align: 'center',value: 'categorySignal', sortable: false },
      ],
      folderList: [],
      folderListFilter: [],
      selectedFolderSection: "ALL",
      selectedEvaluationOption: "ALL",
      selectedSearchType: "CATEGORY_NAME",
      searchValue: "",
      rtnSearchValue: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      maxBytes: 80,
    };
  },
  mounted() {
    // this.getProjectFolderManageList(false);
  },
  watch: {},
  methods: {
    ...mapActions("restAction", [
      "COWORK_REST_SIMPLE_ACTION",
      "COWORK_REST_ACTION",
    ]),
    ...mapActions("modals", ["showToast", "showModal"]),

    /* 폴더 리스트 조회 */
    getProjectFolderManageList(isSearch) {
      let obj = this;
      if (isSearch) {
        if (obj.searchValue == "") {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB091");
          obj.showToast(obj.toastInfo);
          return;
        }
      }
      obj.groupId = this.$props.info.groupId;
      obj.projectId = this.$props.info.projectId;
      let reqData = {};
      reqData.params = {
        projectId: obj.projectId,
        groupId: obj.groupId,
        searchType: obj.selectedSearchType,
        searchValue: "%" + obj.searchValue + "%",
      };
      obj.rtnSearchValue = obj.searchValue;
      obj.isSearchDataExists = false;
      if (obj.searchValue != null && obj.searchValue != "") {
        obj.isSearchDataExists = true;
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/getProjectFolderManageList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.selected = [];
          obj.changedFolderList = [];
          obj.folderList = res.result.categoryList;
          obj.folderListFilter = obj.folderList;
          obj.setFolderFilter();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 폴더 리스트 필터 */
    setFolderFilter() {
      let obj = this;
      // 대시보드 속성 필터링
      // if(obj.selectedFolderSection != "ALL") {
      //     const result = obj.folderList.filter(function(folder){
      //         return folder.section == obj.selectedFolderSection;
      //     });
      //     obj.folderListFilter = result;
      // } else {
      //     obj.folderListFilter = obj.folderList;
      // }

      // 평가정보 필터링
      // if(obj.selectedEvaluationOption != "ALL") {
      //     const result = obj.folderListFilter.filter(function(folder){
      //         return folder.categorySignal == (obj.selectedEvaluationOption == "AUTO" ? null : obj.selectedEvaluationOption);
      //     });
      //     obj.folderListFilter = result;
      // } else {
      //     obj.folderListFilter = obj.folderListFilter;
      // }
    },
    clearSearchFolder() {
      let obj = this;
      obj.searchValue = "";
      obj.rtnSearchValue = "";
      obj.isSearchDataExists = false;
      obj.getProjectFolderManageList(false);
    },
    /* 폴더 수정 버튼 */
    folderEdit(_event, folderItem) {
      if (folderItem.edit != "edit") {
        folderItem.edit = "edit";
      } else {
        folderItem.edit = "";
      }
    },
    /* byte 체크 */
    displayBytes(byteLength, item, _event) {
      let obj = this;
      item.newCategoryName = _event.target.value;
      let checkBytes = obj.getComByteLength(item.newCategoryName);
      item.checkBytes = checkBytes;
      item.error = false;
      item.editError = "";
      if (checkBytes > byteLength) {
        item.editError = "ERROR";
      }
      if (checkBytes == 0) {
        item.error = true;
      }
    },
    /* 저장 버튼 */
    applyCategoryName(item) {
      let obj = this;
      if (item.newCategoryName != null && item.newCategoryName != undefined) {
        if (item.editError != "ERROR") {
          if (item.newCategoryName.length > 0) {
            obj.saveCategoryName(item);
          } else {
            item.error = true;
          }
        }
      }
    },
    /* 폴더명 변경 */
    saveCategoryName(_data) {
      let obj = this;
      // _data.duplicateError = false;
      // _data.edit = "";
      // if (obj.folderList != null && obj.folderList.length > 0) {
      // let isFlag = false;
      // obj.folderList.forEach((fol) => {
      //   if (_data.categoryMid != fol.categoryMid) {
      //     if (_data.newCategoryName == fol.categoryName) {
      //       isFlag = true;
      //     }
      //   }
      // });
      // if (isFlag) {
      // _data.duplicateError = true;
      // _data.edit = "edit";
      // return;
      // }
      // }
      // _data.edit = "edit";

      let reqData = {};
      reqData.params = _data;
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/updateCategoryName";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB023");
          obj.showToast(obj.toastInfo);
          obj.getProjectFolderManageList(false);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 변경사항 저장 */
    // changedInfoSave(kind, toastParam) {
    //     let obj = this;
    //     obj.changedFolderList = [];
    //     if(obj.folderList.length > 0) {
    //         obj.folderList.forEach(checkedFolder => {
    //             let isFlag = true;
    //             if(checkedFolder.oldCategorySignal != checkedFolder.categorySignal
    //                 || checkedFolder.oldSection != checkedFolder.section
    //             ) {
    //                 obj.changedFolderList.forEach(changedFolder => {
    //                     if(changedFolder.categoryMid === checkedFolder.categoryMid) {
    //                         isFlag = false;
    //                     }
    //                 });
    //                 if(isFlag) {
    //                     obj.changedFolderList.push(checkedFolder);
    //                 }
    //             }
    //         });
    //     }
    //     if(obj.changedFolderList.length == 0) {
    //         obj.showAlertDialog("변경된 정보가 없습니다.");
    //         return;
    //     }
    //     let reqData = {};
    //     reqData.params =  {
    //         changedFolderList: obj.changedFolderList
    //     };
    //     reqData.req = obj.req;
    //     reqData.url = "/api/copaper/category/updateCategoryList";
    //     reqData.method = "post";
    //     obj
    //         .COWORK_REST_SIMPLE_ACTION(reqData)
    //         .then((res) => {
    //             if(kind == 'SECTION') {
    //                 obj.toastInfo.message = obj.$i18nUtil.trans('TB066', toastParam);
    //             }
    //             else if(kind == 'EVALUATION') {
    //                 obj.toastInfo.message = obj.$i18nUtil.trans('TB055', toastParam);
    //             }
    //             obj.showToast(obj.toastInfo);
    //             // obj.$emit("closeModal");
    //             obj.getProjectFolderManageList();
    //         })
    //         .catch(function (err) {
    //             console.log(err);
    //         });
    // },
    /* 폴더 삭제 */
    deleteFolder() {
      let obj = this;
      // obj.closeMoreLayer("#dtCheckedChange");
      if (
        obj.selected == null ||
        obj.selected == undefined ||
        obj.selected.length == 0
      ) {
        obj.showAlertDialog(obj.$i18nUtil.trans("AG011"));
        return;
      }
      if (obj.selected.length > 0) {
        let message = obj.$i18nUtil.trans("message.BoardList.004")+"\r\n"+obj.$i18nUtil.trans("message.BoardList.005");
        // if (confirm("삭제 시 해당 단계 하위의 보드가 모두 삭제됩니다.\n단계를 삭제하시겠습니까?") == true) {
        obj.showConfirmDialog(
          null,
          obj.$i18nUtil.trans("title.dialog.notice","알림"),
          message,
          obj.$i18nUtil.trans("button.dialog.delete","삭제"),
          obj.deleteCallback,
          null,
          obj.$i18nUtil.trans("button.cancel","취소"),
          null
        );
      }
    },
    /* 삭제 콜백 */
    deleteCallback(callbackData) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        deleteFolderList: obj.selected,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/deleteCategoryList";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (
            res.errorCode != null &&
            res.errorCode == "DELETE_FOLDER_NOT_AVAILABLE"
          ) {
            obj.showAlertDialog(obj.$i18nUtil.trans("AB032"));
            return;
          }
          obj.toastInfo.message = obj.$i18nUtil.trans("TB024");
          obj.showToast(obj.toastInfo);
          obj.getProjectFolderManageList(false);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 선택폴더 변경 */
    // setCheckedChange(_event, kind, type, typeTxt) {
    //     let obj = this;
    //     obj.closeMoreLayer("#dtCheckedChange");
    //     if(obj.selected == null || obj.selected == undefined || obj.selected.length == 0) {
    //         obj.showAlertDialog("을 선택해주세요.");
    //         return;
    //     }
    //     if(obj.selected.length > 0) {
    //         obj.selected.forEach(checkedFolder => {
    //             if(kind == "SECTION") {
    //                 checkedFolder.section = type;
    //                 checkedFolder.sectionName = typeTxt;
    //                 obj.changedInfoSave(kind, {dashboardAttributeName: typeTxt});
    //             }
    //             else if(kind == "EVALUATION") {
    //                 checkedFolder.categorySignal = typeTxt;
    //                 obj.changedInfoSave(kind, {evaluationName: typeTxt});
    //             }
    //         });
    //     }
    // },
    /* 대시보드 속성 필터 */
    // filterFolderSection(_event, type) {
    //     let obj = this;
    //     obj.closeMoreLayer("#dtSection");
    //     obj.selectedFolderSection = type;
    //     obj.setFolderFilter();
    // },
    /* 평가상태 필터 */
    // filterEvaluationOption(_event, type, typeTxt) {
    //     let obj = this;
    //     obj.closeMoreLayer("#dtEvaluation");
    //     obj.selectedEvaluationOption = typeTxt;
    //     obj.setFolderFilter();
    // },
    /* 검색조건 필터 */
    filterSearchType(type) {
      let obj = this;
      // obj.closeMoreLayer("#dtSearchType");
      obj.selectedSearchType = type;
    },
    /* 더보기 레이어 닫기 */
    // closeMoreLayer(findId) {
    //   if (
    //     $(findId) !== null ||
    //     $(findId) !== undefined ||
    //     $(findId).length > 0
    //   ) {
    //     if ($(findId).length == 1) {
    //       if ($(findId)[0].classList.contains("active")) {
    //         $(findId)[0].classList.toggle("active");
    //       }
    //     }
    //   }
    // },
    /* 상세옵션 정보 */
    getEvaluationOption(evaluationCode) {
      let rtnEvaluateText = "";
      // exceeded
      if (evaluationCode == "ALL") {
        rtnEvaluateText = "진행상태 전체";
      } else if (evaluationCode == "GOOD") {
        rtnEvaluateText = "정상";
      }
      // on track
      else if (evaluationCode == "SO") {
        rtnEvaluateText = "이슈 발생";
      }
      // at risk
      else if (evaluationCode == "DELAY") {
        rtnEvaluateText = "보고 필요";
      }
      // off track
      else if (evaluationCode == "EXCEEDED") {
        rtnEvaluateText = "종료";
      }
      return rtnEvaluateText;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectFolderManage.vue